import { render, staticRenderFns } from "./ExpedientActionsResumeWidget.vue?vue&type=template&id=5d7fb205&scoped=true"
import script from "./ExpedientActionsResumeWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientActionsResumeWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientActionsResumeWidget.vue?vue&type=style&index=0&id=5d7fb205&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7fb205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7fb205')) {
      api.createRecord('5d7fb205', component.options)
    } else {
      api.reload('5d7fb205', component.options)
    }
    module.hot.accept("./ExpedientActionsResumeWidget.vue?vue&type=template&id=5d7fb205&scoped=true", function () {
      api.rerender('5d7fb205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientActionsResume/ExpedientActionsResumeWidget.vue"
export default component.exports